import { Link } from "gatsby";
import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Col, Container, Row } from "react-bootstrap";
import Img1 from "../../../images/locationgcc/sa/equitrip.webp";
import Img2 from "../../../images/locationgcc/sa/al_hussaini.webp";
import Img3 from "../../../images/locationgcc/sa/save_win.webp";

const CaseStudy = [
  {
    title: "Equi Trip",
    description: "Digital platform for horse industry stakeholders to connect.",
    link: "equi-trip",
    Img: Img1,
    BgColor: "#173768",
    TextColor: "#FFFFFF",
  },
  {
    title: "Al Hussaini",
    description: "Leading marketplace in Saudi Arabia for watches and jewelry.",
    link: "alhussaini",
    Img: Img2,
    BgColor: "#ba7f4c",
    TextColor: "#FFFFFF",
  },
  {
    title: "Save & Win",
    description:
      "Money-saving application that enables users to compare the prices.",
    link: "save-win",
    Img: Img3,
    BgColor: "#198463",
    TextColor: "#FFFFFF",
  },
];

const StoriesCase = () => {
  return (
    <div className="case_section">
      <Container className="h-100">
        <Row className="h-100">
          {CaseStudy.map((item, index) => (
            <Col
              xs={12}
              md={12}
              lg={10}
              xl={4}
              xxl={4}
              className="my-xl-auto m-lg-auto "
            >
              <div
                className="bg_case"
                style={{ backgroundColor: item.BgColor }}
              >
                <div className="case-content">
                  <h4 style={{ color: item.TextColor }}>{item.title}</h4>
                  <p style={{ color: item.TextColor }}>{item.description}</p>
                  <Link
                    to={
                      item.link
                        ? `/case-studies/${item.link}`
                        : "https://www.tekrevol.com/projects"
                    }
                    className="btn_case"
                  >
                    View Full Casestudy
                  </Link>
                </div>
                <div className="case-img">
                  <LazyLoadImage
                    src={item.Img}
                    effect="blur"
                    alt="Image"
                    className="img-fluid"
                  />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default StoriesCase;
